var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pcPlayer",staticClass:"pcPlayer",class:_vm.$style.playerWrap},[_c('div',{class:_vm.$style.videoPlayer,style:(_vm.playerStyle)},[_c('video',{ref:"videoPlayer",staticClass:"video-js",class:_vm.$style.videojs})])])}
var staticRenderFns = []

export { render, staticRenderFns }